// hooks/useSideNavigation.ts
import { useState, useEffect, useCallback } from "react";
import {
  fetchSideMenu,
  fetchSideMenuDataById,
  fetchXevmpdDataById
} from "../api/apiFunctions";
import { useLocation, useParams } from "react-router-dom";
import { MenuItem } from "../pages/idmp/SideNavigation";

// ✅ Types
interface SideMenuId {
  registrationId: string;
  productId: string;
}

interface SideMenuData {
  fieldData: any[]; // you can strongly type later
  formData: Record<string, any>;
}

export const useSideNavigation = () => {
  const location = useLocation();
   const {recordId} = useParams();
   const xevmpdid = recordId?recordId:location.state?.params.xevmpdId;
  const paramss = location.state?.params;

  // ✅ States
  const [sideMenus, setSideMenus] = useState<MenuItem[]>([]);
  const [sideMenuIds, setSideMenuIds] = useState<SideMenuId | null>(null);
  const [sideMenuData, setSideMenuData] = useState<SideMenuData>({
    fieldData: [],
    formData: {}
  });
  const [loading, setLoading] = useState<boolean>(true);
  const [pageTitle, setPageTitle] = useState<string>("xEVMPD");

  // ✅ Load initial data
  const loadMenus = useCallback(async () => {
    try {
      setLoading(true);

      const xevmpdResponse = await fetchXevmpdDataById(xevmpdid);

      const ids: SideMenuId = {
        registrationId: xevmpdResponse?.xevmpdData?.Regdata?.id,
        productId: xevmpdResponse?.xevmpdData?.Regdata?.productId
      };

      setSideMenuIds(ids);

      const response = await fetchSideMenu();
      setSideMenus(response || []);
    } catch (error) {
      console.error("Error loading menus:", error);
    } finally {
      setLoading(false);
    }
  }, [xevmpdid]);

  useEffect(() => {
    loadMenus();
  }, []);

  // ✅ Handle menu change
  const onSideMenuChange = useCallback(
    async (node: MenuItem) => {
      if (!sideMenuIds) return;

      try {
        setLoading(true);

        const parameters = {
          regId: sideMenuIds.registrationId,
          productId: sideMenuIds.productId,
          name: node.name,
          xevmpdId: xevmpdid
        };

        if (!node.associatedGrid) {
          const response = await fetchSideMenuDataById(parameters);

          const { dynamicFieldJson, fieldData: formData } = response;

          let fieldData = JSON.parse(dynamicFieldJson || "[]");

          // ✅ Optimize filtering + sorting
          if (node.name === "xEVMPD") {
            fieldData = fieldData
              ?.filter((item: any) => item?.edit_xevmpd)
              .sort(
                (a: any, b: any) =>
                  (a.order ?? 0) - (b.order ?? 0)
              );
          }

          setSideMenuData({ fieldData, formData });
        }

        setPageTitle(node.name);
      } catch (error) {
        console.error("Error loading side menu data:", error);
      } finally {
        setLoading(false);
      }
    },
    [sideMenuIds, xevmpdid]
  );

  return {
    sideMenus,
    sideMenuData,
    loading,
    pageTitle,
    onSideMenuChange,
    setPageTitle,
    paramss,
    setLoading
  };
};